(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moreno-product-information')) {
    class MorenoProductInformation extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.panels = Array.from(this.children).filter((element) => element.tagName === 'DETAILS');
        this.handleClick = this.onClick.bind(this);
        this.handleToggle = this.onToggle.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
        this.handleResize = this.updateBodyHeight.bind(this);
        const initialPanel = this.panels.find((panel) => panel.open) || this.panels[0];
        this.panels.forEach((panel) => { panel.open = panel === initialPanel; });
        this.addEventListener('click', this.handleClick);
        this.addEventListener('toggle', this.handleToggle, true);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        window.addEventListener('resize', this.handleResize);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this);
          this.panels.forEach((panel) => this.resizeObserver.observe(panel.querySelector('summary')));
        }
        this.updateBodyHeight();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.updateBodyHeight(); });
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('toggle', this.handleToggle, true);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.initialized = false;
      }

      closeOtherPanels(activePanel) {
        this.panels.forEach((panel) => { if (panel !== activePanel) panel.open = false; });
      }

      onClick(event) {
        if (!(event.target instanceof Element)) return;
        const summary = event.target.closest('summary');
        const panel = summary && summary.parentElement;
        if (!this.panels.includes(panel)) return;
        if (!panel.open) this.closeOtherPanels(panel);
        this.updateBodyHeight();
      }

      onToggle(event) {
        const panel = event.target;
        if (!this.panels.includes(panel) || !panel.open) return;
        this.closeOtherPanels(panel);
        const content = panel.querySelector('.mc-acc__body');
        if (content) content.scrollTop = 0;
        this.updateBodyHeight();
      }

      onBlockSelect(event) {
        if (!(event.target instanceof Element)) return;
        const panel = event.target.closest('details');
        if (!this.panels.includes(panel)) return;
        this.closeOtherPanels(panel);
        panel.open = true;
      }

      updateBodyHeight() {
        if (!window.matchMedia('(min-width: 768px)').matches) {
          this.style.removeProperty('--mc-accordion-body-height');
          return;
        }
        const headersHeight = this.panels.reduce((height, panel) => {
          const style = window.getComputedStyle(panel);
          return height + panel.querySelector('summary').getBoundingClientRect().height
            + (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
        }, 0);
        const availableHeight = Math.max(80, Math.floor(this.clientHeight - headersHeight));
        this.style.setProperty('--mc-accordion-body-height', availableHeight + 'px');
      }
    }
    customElements.define('moreno-product-information', MorenoProductInformation);
  }
  } catch(e) { console.error(e); }
})();

})();
